import { z } from 'zod';

import { EMAIL_REGEXP } from 'services/util/auxiliaryUtils';

// Error messages are translation ids: the forms show them through getFormErrorMessage.

/** A form field as text. Inputs give text, but a field left as loaded keeps the value the API sent: a number, or none. */
export const fieldTextSchema = z
    .union([z.string(), z.number()])
    .nullish()
    .transform((value) => (value === null || value === undefined ? '' : String(value)));

export const requiredFieldSchema = fieldTextSchema.pipe(z.string().min(1, 'yup.message.required'));

export const nifFieldSchema = fieldTextSchema.pipe(z.string().min(1, 'yup.message.required').length(9, 'yup.message.nifLength'));

export const requiredEmailFieldSchema = fieldTextSchema.pipe(
    z.string().min(1, 'yup.message.required').regex(EMAIL_REGEXP, 'yup.message.email')
);

/** The value of an option chosen in a select or combobox: the option's id, as the list sent it. */
export const selectedValueSchema = z.union([z.number(), z.string()]);
